module.exports = __webpack_public_path__ + "static/media/lg-walls-of-arith.93e98cfe.jpg";